import path from "path";
import { readdirSync, readFileSync } from "node:fs";
import { open, readdir } from "node:fs/promises";
import lazyRequire from "../../../util/lazyRequire";
export class VortexModInstallerFileSystem {
    fomod;
    mFileSystem;
    constructor() {
        this.fomod = lazyRequire(() => require("@nexusmods/fomod-installer-native"));
        this.mFileSystem = new this.fomod.NativeFileSystem(this.readFileContent, this.readDirectoryFileList, this.readDirectoryList);
    }
    useVortexFunctions = () => {
        this.mFileSystem.setCallbacks();
    };
    useLibraryFunctions = () => {
        this.fomod.NativeFileSystem.setDefaultCallbacks();
    };
    /**
     * Callback
     */
    readFileContent = (filePath, offset, length) => {
        try {
            if (offset === 0 && length === -1) {
                const data = readFileSync(filePath);
                return new Uint8Array(data);
            }
            else if (offset >= 0 && length > 0) {
                // TODO: read the chunk we actually need, but there's no readFile()
                //const fd = fs.openSync(filePath, 'r');
                //const buffer = Buffer.alloc(length);
                //fs.readSync(fd, buffer, offset, length, 0);
                return new Uint8Array(readFileSync(filePath)).slice(offset, offset + length);
            }
            else {
                return null;
            }
        }
        catch {
            return null;
        }
    };
    /**
     * Callback
     */
    readDirectoryFileList = (directoryPath) => {
        try {
            return readdirSync(directoryPath, { withFileTypes: true })
                .filter((x) => x.isFile())
                .map((x) => path.join(directoryPath, x.name));
        }
        catch {
            return null;
        }
    };
    /**
     * Callback
     */
    readDirectoryList = (directoryPath) => {
        try {
            return readdirSync(directoryPath, { withFileTypes: true })
                .filter((x) => x.isDirectory())
                .map((x) => path.join(directoryPath, x.name));
        }
        catch {
            return null;
        }
    };
    /**
     * Callback
     */
    readFileContentAsync = async (filePath, offset, length) => {
        try {
            let fileHandle = null;
            try {
                fileHandle = await open(filePath, "r");
                if (length === -1) {
                    const stats = await fileHandle.stat();
                    length = stats.size;
                }
                const buffer = this.fomod.allocWithoutOwnership(length) ?? new Uint8Array(length);
                await fileHandle.read(buffer, 0, length, offset);
                return buffer;
            }
            finally {
                await fileHandle?.close();
            }
        }
        catch (err) {
            // ENOENT means that a file or folder is not found, it's an expected error
            if (err instanceof Error && "code" in err && err.code === "ENOENT") {
                return null;
            }
            //const { localize: t } = LocalizationManager.getInstance(this.api);
            //this.api.showErrorNotification?.(t('Error reading file content'), err);
        }
        return null;
    };
    /**
     * Callback
     */
    readDirectoryFileListAsync = async (directoryPath) => {
        try {
            const dirs = await readdir(directoryPath, { withFileTypes: true });
            const res = dirs
                .filter((x) => x.isFile())
                .map((x) => path.join(directoryPath, x.name));
            return res;
        }
        catch (err) {
            // ENOENT means that a file or folder is not found, it's an expected error
            if (err instanceof Error && "code" in err && err.code === "ENOENT") {
                return null;
            }
            //const { localize: t } = LocalizationManager.getInstance(this.api);
            //this.api.showErrorNotification?.(t('Error reading directory file list'), err);
        }
        return null;
    };
    /**
     * Callback
     */
    readDirectoryListAsync = async (directoryPath) => {
        try {
            const dirs = await readdir(directoryPath, { withFileTypes: true });
            const res = dirs
                .filter((x) => x.isDirectory())
                .map((x) => path.join(directoryPath, x.name));
            return res;
        }
        catch (err) {
            // ENOENT means that a file or folder is not found, it's an expected error
            if (err instanceof Error && "code" in err && err.code === "ENOENT") {
                return null;
            }
            //const { localize: t } = LocalizationManager.getInstance(this.api);
            //this.api.showErrorNotification?.(t('Error reading directory list'), err);
        }
        return null;
    };
}
